// Banner fijo de "Ver como" (plataforma) — visible cuando la sesión actual es impersonada.
// AUTOCONTENIDO: consulta /me/permissions al montar (no toca el AuthContext grande).
// ⚠️ Las acciones durante ver-como son reales y quedan a nombre del usuario visto.
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Eye, LogOut } from 'lucide-react';
import { baseAuthApi } from '../../api/baseAuthApi';

export default function ImpersonationBanner() {
  const [viewing, setViewing] = useState<string | null>(null);

  useEffect(() => {
    baseAuthApi.permissions()
      .then((p) => { if (p.impersonator && p.user) setViewing(p.user.name); })
      .catch(() => {});
  }, []);

  if (!viewing) return null;

  const exit = async () => {
    try { await baseAuthApi.stopImpersonation(); } catch { /* si expiró, recargar manda a login */ }
    window.location.href = '/';
  };

  return createPortal(
    <div className="fixed inset-x-0 bottom-0 z-[1400] flex justify-center pb-3 pointer-events-none">
      <div className="pointer-events-auto flex items-center gap-2.5 rounded-full border border-amber-600/50 bg-amber-500 px-4 py-2 text-sm font-semibold text-black shadow-xl">
        <Eye size={16} />
        <span>Viendo como {viewing}</span>
        <button onClick={exit}
          className="ml-1 flex items-center gap-1 rounded-full bg-black/80 px-2.5 py-1 text-xs font-semibold text-white transition hover:bg-black">
          <LogOut size={12} /> Volver a plataforma
        </button>
      </div>
    </div>,
    document.body
  );
}
